/**
 * Chart Finder — SailorShop.co.uk
 * (c) SailorShop.co.uk — chart coverage data is proprietary.
 */
;(function () {
  'use strict';

  var DATA_URL = window.__chartFinderDataUrl;
  if (!DATA_URL) { console.error('Chart Finder: no data URL'); return; }

  var MAP_CENTER = [50.5, -3.5], MAP_ZOOM = window.innerWidth < 769 ? 5 : 6;
  // CARTO stamps an "API KEY REQUIRED" watermark across raster tiles served
  // without a key. The key is set by snippets/carto-basemap-key.liquid — see
  // there for why it is public and where to rotate it.
  var CARTO_KEY = window.__cartoBasemapKey || '';
  var TILE_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png'
                 + (CARTO_KEY ? '?key=' + encodeURIComponent(CARTO_KEY) : '');
  var TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>';
  var ALL_TYPES = ['Ocean','Passage','Coastal','Approach','Harbour'];

  var CHART_DATA = null, map = null;
  var polygonsByEntry = new Map(), allMapEntries = [], entriesById = new Map();
  var activeEntry = null, activePolygon = null, hoveredPoly = null, hoveredEntry = null;
  var seriesVisible = {}, typeVisible = {};
  ALL_TYPES.forEach(function(t){ typeVisible[t] = true; });
  var cartVariantIds = new Set();
  var isMobile = window.innerWidth < 769;

  // View mode: 'charts' or 'packs'
  var viewMode = 'charts';
  var chartEntries = [], packEntries = [];

  var $map, $bar, $modalBackdrop, $toast, $tooltip;
  var $legend, $legendToggle, $legendRows, $typeFilterRows, $seriesSection, $typeSection;
  var $searchInput, $searchClear, $searchDropdown;
  var $modeCharts, $modePacks;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    $map            = document.getElementById('cf-map');
    $bar            = document.getElementById('cf-bar');
    $modalBackdrop  = document.getElementById('cf-modal-backdrop');
    $toast          = document.getElementById('cf-toast');
    $tooltip        = document.getElementById('cf-tooltip');
    $legend         = document.getElementById('cf-legend');
    $legendToggle   = document.getElementById('cf-legend-toggle');
    $legendRows     = document.getElementById('cf-legend-rows');
    $typeFilterRows = document.getElementById('cf-type-filter-rows');
    $seriesSection  = document.getElementById('cf-series-section');
    $typeSection    = document.getElementById('cf-type-section');
    $searchInput    = document.getElementById('cf-search-input');
    $searchClear    = document.getElementById('cf-search-clear');
    $searchDropdown = document.getElementById('cf-search-dropdown');
    $modeCharts     = document.getElementById('cf-mode-charts');
    $modePacks      = document.getElementById('cf-mode-packs');
    if (!$map) return;

    initMap();
    fetchData();
    initSearch();
    initBar();
    initModal();
    initLegendClose();
    initModeToggle();
    window.addEventListener('resize', function(){ isMobile = window.innerWidth < 769; if(map) map.invalidateSize(); });
    fetchCartState();
  }

  function initMap() {
    map = L.map($map, { center: MAP_CENTER, zoom: MAP_ZOOM, zoomControl: true, scrollWheelZoom: true });
    L.tileLayer(TILE_URL, { attribution: TILE_ATTR, maxZoom: 18, subdomains: 'abcd' }).addTo(map);
    map.on('click', function(e) { selectEntryFromPoint(e.latlng.lat, e.latlng.lng); });
  }

  /* ── Data ── */
  function fetchData() {
    fetch(DATA_URL).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.json(); })
    .then(function(data) {
      CHART_DATA = data;
      chartEntries = data.charts || [];
      packEntries = data.packs || [];
      var all = chartEntries.concat(packEntries);
      all.forEach(function(e){ entriesById.set(e.id, e); });

      // Init series visibility (only for chart series, not 'pack')
      var allSeries = [];
      chartEntries.forEach(function(e){ if(allSeries.indexOf(e.series)===-1) allSeries.push(e.series); });
      allSeries.forEach(function(s){ seriesVisible[s] = true; });
      seriesVisible['pack'] = true;

      // Draw initial view (charts only)
      drawPolygons(chartEntries);
      buildLegend(chartEntries);
      buildTypeFilter();
      buildSearchIndex(all);

      var $loading = document.getElementById('cf-loading');
      if($loading) $loading.classList.add('hidden');
      setTimeout(function(){ map.invalidateSize(); }, 100);
    })
    .catch(function(err) {
      console.error('Chart Finder: data load failed', err);
      var $l = document.getElementById('cf-loading');
      if($l) $l.classList.add('hidden');
      var $e = document.getElementById('cf-error');
      if($e) $e.style.display = 'block';
    });
  }

  /* ── Mode toggle (Charts / Packs) ── */
  function initModeToggle() {
    if ($modeCharts) $modeCharts.addEventListener('click', function(){ setMode('charts'); });
    if ($modePacks) $modePacks.addEventListener('click', function(){ setMode('packs'); });
  }

  function setMode(mode) {
    if (mode === viewMode) return;
    viewMode = mode;

    // Update toggle buttons
    if ($modeCharts) $modeCharts.classList.toggle('active', mode === 'charts');
    if ($modePacks) $modePacks.classList.toggle('active', mode === 'packs');

    // Show/hide series + type filters (only relevant for charts; packs contain all types)
    if ($seriesSection) $seriesSection.style.display = mode === 'charts' ? '' : 'none';
    if ($typeSection) $typeSection.style.display = mode === 'charts' ? '' : 'none';

    // Close bar and clear selection
    closeBar();

    // Remove all polygons from map
    polygonsByEntry.forEach(function(poly) { if(map.hasLayer(poly)) poly.removeFrom(map); });
    polygonsByEntry.clear();
    allMapEntries.length = 0;

    // Draw the right set
    var entries = mode === 'charts' ? chartEntries : packEntries;
    drawPolygons(entries);

    // Re-apply cart highlights
    allMapEntries.forEach(function(e){ updatePolyCartHighlight(e); });
  }

  /* ── Polygons ── */
  function effectiveArea(entry) {
    var coords = entry.coordinates;
    if(!coords||!coords.length) return 0;
    var isMulti = Array.isArray(coords[0][0]);
    var rings = isMulti ? coords : [coords];
    var minLat=90,maxLat=-90,minLng=180,maxLng=-180;
    rings.forEach(function(ring){
      ring.forEach(function(p){ if(p[0]<minLat)minLat=p[0]; if(p[0]>maxLat)maxLat=p[0]; if(p[1]<minLng)minLng=p[1]; if(p[1]>maxLng)maxLng=p[1]; });
    });
    return (maxLat-minLat)*(maxLng-minLng);
  }

  function styleFor(entry, state) {
    var c = entry.color||'#888', pk = entry.series==='pack';
    var s = {
      'default': { color:c, weight:pk?2:1.5, opacity:pk?0.7:0.55, fillColor:c, fillOpacity:pk?0.04:0.06, dashArray:pk?'6,4':null },
      hover:   { color:c, weight:2.5, opacity:1, fillColor:c, fillOpacity:pk?0.1:0.15, dashArray:pk?'6,4':null },
      active:  { color:c, weight:3, opacity:1, fillColor:c, fillOpacity:pk?0.12:0.2, dashArray:pk?'6,4':null },
    };
    return s[state]||s['default'];
  }

  function drawPolygons(entries) {
    // Sort: largest area first → drawn first → renders behind smaller charts
    var ordered = entries.slice().sort(function(a,b){ return effectiveArea(b)-effectiveArea(a); });

    ordered.forEach(function(entry) {
      var coords = entry.coordinates;
      if(!coords||!coords.length) return;
      var isMulti = Array.isArray(coords[0][0]);
      if(!isMulti && coords.length<3) return;

      // Skip if not visible per current filters
      if (!isEntryVisible(entry)) return;

      var poly = L.polygon(coords, styleFor(entry,'default'));
      poly.on('mouseover', function(e){
        if(hoveredPoly && hoveredPoly !== poly && hoveredEntry !== activeEntry) {
          hoveredPoly.setStyle(styleFor(hoveredEntry,'default'));
          updatePolyCartHighlight(hoveredEntry);
        }
        hoveredPoly = poly; hoveredEntry = entry;
        if(entry!==activeEntry) poly.setStyle(styleFor(entry,'hover'));
        showTooltip(e.originalEvent, entry);
      });
      poly.on('mousemove', function(e){ moveTooltip(e.originalEvent); });
      poly.on('mouseout', function(){ if(entry!==activeEntry) poly.setStyle(styleFor(entry,'default')); updatePolyCartHighlight(entry); hoveredPoly=null; hoveredEntry=null; hideTooltip(); });
      poly.on('click', function(e){ L.DomEvent.stopPropagation(e); selectEntryFromPoint(e.latlng.lat, e.latlng.lng); });

      poly.addTo(map);
      polygonsByEntry.set(entry.id, poly);
      allMapEntries.push(entry);
      updatePolyCartHighlight(entry);
    });
  }

  /* ── Point-in-polygon ── */
  function pointInRing(lat,lng,ring) {
    var inside=false;
    for(var i=0,j=ring.length-1;i<ring.length;j=i++){
      var yi=ring[i][0],xi=ring[i][1],yj=ring[j][0],xj=ring[j][1];
      if(((yi>lat)!==(yj>lat))&&(lng<(xj-xi)*(lat-yi)/(yj-yi)+xi)) inside=!inside;
    }
    return inside;
  }
  function pointInCoords(lat,lng,coords) {
    if(!coords||!coords.length)return false;
    if(Array.isArray(coords[0][0])) return coords.some(function(r){return pointInRing(lat,lng,r);});
    return pointInRing(lat,lng,coords);
  }

  function selectEntryFromPoint(lat,lng) {
    var hits=[];
    allMapEntries.forEach(function(e){
      if(!isEntryVisible(e))return;
      if(!polygonsByEntry.has(e.id)) return;
      if(!map.hasLayer(polygonsByEntry.get(e.id))) return;
      if(pointInCoords(lat,lng,e.coordinates)) hits.push({entry:e,area:effectiveArea(e)});
    });
    if(!hits.length){ closeBar(); return; }
    // Smallest area first = most specific chart
    hits.sort(function(a,b){ return a.area - b.area; });
    selectEntry(hits[0].entry);
  }

  /* ── Visibility ── */
  function isEntryVisible(entry) {
    // In packs mode, only packs visible; in charts mode, only charts
    if (viewMode === 'charts' && entry.series === 'pack') return false;
    if (viewMode === 'packs' && entry.series !== 'pack') return false;

    if (viewMode === 'charts' && !seriesVisible[entry.series]) return false;

    var types = entry.types||[];
    if(!types.length) return true;
    return types.some(function(t){return typeVisible[t]!==false;});
  }

  function applyVisibility() {
    // Re-evaluate visibility for all entries in current mode
    var entries = viewMode === 'charts' ? chartEntries : packEntries;
    entries.forEach(function(entry) {
      var poly = polygonsByEntry.get(entry.id);
      if (!poly) return;
      var vis = isEntryVisible(entry);
      if (vis && !map.hasLayer(poly)) poly.addTo(map);
      else if (!vis && map.hasLayer(poly)) poly.removeFrom(map);
    });
    // Reorder to maintain smallest-on-top
    reorderPolygons();
  }

  function reorderPolygons() {
    // Sort visible polygons so smallest area is on top.
    // Leaflet: bringToFront puts a layer on top of all others.
    // Process from largest to smallest, calling bringToFront on each.
    // The last one (smallest) ends up on top.
    var sorted = allMapEntries.slice().sort(function(a,b){ return effectiveArea(b)-effectiveArea(a); });
    sorted.forEach(function(e) {
      var p = polygonsByEntry.get(e.id);
      if (p && map.hasLayer(p)) p.bringToFront();
    });
  }

  /* ── Selection ── */
  function selectEntry(entry) {
    if(activePolygon && activeEntry) {
      activePolygon.setStyle(styleFor(activeEntry,'default'));
      updatePolyCartHighlight(activeEntry);
    }
    var poly = polygonsByEntry.get(entry.id);
    activeEntry = entry;
    activePolygon = poly;
    if(poly) poly.setStyle(styleFor(entry,'active'));
    showBar(entry);
  }

  /* ================================================================
     BOTTOM BAR
     ================================================================ */
  function initBar() {
    if(!$bar) return;
    $bar.querySelector('.cf-bar-close').addEventListener('click', closeBar);
    $bar.querySelector('.cf-bar-btn-details').addEventListener('click', function(){ if(activeEntry){ modalTriggerEl=this; openModal(activeEntry); } });
    $bar.querySelector('.cf-bar-thumb').addEventListener('click', function(){ if(activeEntry){ modalTriggerEl=this; openModal(activeEntry); } });
  }

  function showBar(entry) {
    if(!$bar) return;
    var prods = entry.products||[];
    var firstP = prods[0]||{};
    var isPack = entry.series==='pack';
    var multiVariant = prods.length > 1;

    var thumb = $bar.querySelector('.cf-bar-thumb');
    thumb.src = firstP.chartImage || firstP.coverImage || '';
    thumb.alt = entry.chartRef;

    var seriesEl = $bar.querySelector('.cf-bar-series');
    seriesEl.textContent = isPack ? 'Chart Pack' : (CHART_DATA.seriesLabels[entry.series]||entry.series);
    seriesEl.style.color = entry.color;
    $bar.querySelector('.cf-bar-ref').textContent = entry.chartRef;
    $bar.querySelector('.cf-bar-title').textContent = entry.shortTitle;

    var prices = prods.map(function(p){return parseFloat(p.price);}).filter(function(p){return !isNaN(p);});
    var priceText = '';
    if(prices.length) {
      var mn = Math.min.apply(null,prices), mx = Math.max.apply(null,prices);
      priceText = mn===mx ? '\u00a3'+mn.toFixed(2) : 'from \u00a3'+mn.toFixed(2);
    }
    $bar.querySelector('.cf-bar-price').textContent = priceText;

    var cartBtn = $bar.querySelector('.cf-bar-btn-cart');
    if (multiVariant) {
      // chart-finder.css sets `display: inline-block !important` on .cf-bar-btn
      // to defend the widget against theme styles, and an !important rule beats
      // a plain inline style. So `style.display = 'none'` was silently ignored
      // and the button stayed on screen for every multi-format entry: the 14
      // merged chart packs and the 29 Y-series charts with a laminated edition.
      // It did nothing when clicked, because this branch never assigns a
      // variantId or a handler. Hiding has to be !important to win.
      cartBtn.style.setProperty('display', 'none', 'important');
    } else {
      cartBtn.style.removeProperty('display');
      var vid = firstP.variantId||0;
      var inCart = cartVariantIds.has(vid);
      cartBtn.dataset.variantId = vid;
      cartBtn.dataset.entryId = entry.id;
      cartBtn.textContent = inCart ? 'In cart \u2713' : 'Add to cart';
      cartBtn.className = 'cf-bar-btn cf-bar-btn-cart' + (inCart ? ' in-cart' : '');
      cartBtn.disabled = false;
      cartBtn.onclick = inCart
        ? function(){ removeFromCart(vid, entry.id, cartBtn, 'bar'); }
        : function(){ addToCart(vid, entry.id, cartBtn, 'bar'); };
    }

    $bar.classList.add('open');
  }

  function closeBar() {
    if($bar) $bar.classList.remove('open');
    if(activePolygon && activeEntry) {
      activePolygon.setStyle(styleFor(activeEntry,'default'));
      updatePolyCartHighlight(activeEntry);
    }
    activeEntry = null; activePolygon = null;
  }

  /* ================================================================
     MODAL
     ================================================================ */
  function initModal() {
    if(!$modalBackdrop) return;
    $modalBackdrop.addEventListener('click', function(e){ if(e.target===$modalBackdrop) closeModal(); });
    $modalBackdrop.querySelector('.cf-modal-close').addEventListener('click', closeModal);
    var imgToggle = $modalBackdrop.querySelector('.cf-modal-img-toggle');
    var img = $modalBackdrop.querySelector('.cf-modal-img');
    if(imgToggle) {
      imgToggle.addEventListener('click', function(){
        if(imgToggle.dataset.mode==='chart') { img.src=imgToggle.dataset.cover; imgToggle.textContent='Show chart'; imgToggle.dataset.mode='cover'; }
        else { img.src=imgToggle.dataset.chart; imgToggle.textContent='Show cover'; imgToggle.dataset.mode='chart'; }
        img.classList.remove('zoomed');
      });
    }
    // Hover-to-zoom: track mouse position for transform-origin
    if(img) {
      // Fullscreen overlay for mobile, CSS zoom for desktop
      var fsOverlay = document.createElement('div');
      fsOverlay.className = 'cf-img-fullscreen';
      fsOverlay.innerHTML = '<img src="" alt=""/><div class="cf-img-fullscreen-hint">Tap to close</div>';
      document.body.appendChild(fsOverlay);
      fsOverlay.addEventListener('click', function(){ fsOverlay.classList.remove('open'); });

      img.addEventListener('click', function(){
        if(isMobile) {
          fsOverlay.querySelector('img').src = img.src;
          fsOverlay.classList.add('open');
        } else {
          img.classList.toggle('zoomed');
        }
      });
      img.addEventListener('mousemove', function(e){
        if(!img.classList.contains('zoomed')) return;
        var rect = img.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
      img.addEventListener('mouseleave', function(){
        img.classList.remove('zoomed');
        img.style.transformOrigin = '';
      });
    }
    document.addEventListener('keydown', function(e){ if(e.key==='Escape' && $modalBackdrop.classList.contains('open')) closeModal(); });
  }

  function openModal(entry) {
    if(!$modalBackdrop) return;
    var isPack = entry.series==='pack';
    var prods = entry.products||[], firstP = prods[0]||{};

    var coverUrl=firstP.coverImage||'', chartUrl=firstP.chartImage||'';
    var img=$modalBackdrop.querySelector('.cf-modal-img');
    img.src=chartUrl||coverUrl||''; img.alt=entry.title;
    img.classList.remove('zoomed'); img.style.transformOrigin='';

    var imgToggle=$modalBackdrop.querySelector('.cf-modal-img-toggle');
    if(coverUrl&&chartUrl){ imgToggle.style.display=''; imgToggle.textContent='Show cover'; imgToggle.dataset.mode='chart'; imgToggle.dataset.cover=coverUrl; imgToggle.dataset.chart=chartUrl; }
    else { imgToggle.style.display='none'; }

    $modalBackdrop.querySelector('.cf-modal-series-bar').style.background=entry.color;
    var tag=$modalBackdrop.querySelector('.cf-modal-series-tag');
    tag.textContent=isPack?'Chart Pack':(CHART_DATA.seriesLabels[entry.series]||entry.series);
    tag.style.color=entry.color;

    $modalBackdrop.querySelector('.cf-modal-chart-ref').textContent=entry.chartRef;
    $modalBackdrop.querySelector('.cf-modal-short-title').textContent=entry.shortTitle;

    var specs=[];
    if(isPack&&entry.chartCount) specs.push(['Charts',entry.chartCount+' charts']);
    if(!isPack&&entry.scale) specs.push(['Scale',entry.scale]);
    if(!isPack&&entry.edition) specs.push(['Edition',entry.edition]);
    if(entry.correctedTo) specs.push(['Corrected to',entry.correctedTo]);
    if(!isPack&&entry.sheetSize) specs.push(['Size',entry.sheetSize]);
    if(!isPack&&entry.chartFormat) specs.push(['Format',entry.chartFormat]);
    if(entry.seaAreas&&entry.seaAreas.length) specs.push(['Sea area',entry.seaAreas.join('; ')]);
    if(!isPack&&entry.plans&&entry.plans.length) specs.push(['Plans',entry.plans.join(', ')]);
    $modalBackdrop.querySelector('.cf-modal-specs').innerHTML=specs.map(function(s){
      return '<div class="cf-modal-spec-row"><span class="cf-modal-spec-label">'+esc(s[0])+'</span><span class="cf-modal-spec-value">'+esc(s[1])+'</span></div>';
    }).join('');

    $modalBackdrop.querySelector('.cf-modal-types').innerHTML=(entry.types||[]).map(function(t){
      return '<span class="cf-type-badge">'+esc(t)+'</span>';
    }).join('');

    var rowsEl=$modalBackdrop.querySelector('.cf-modal-product-rows');
    rowsEl.innerHTML=prods.map(function(p){
      var price=p.price?'\u00a3'+p.price:'\u2014';
      var vid=p.variantId||0, inCart=cartVariantIds.has(vid);
      return '<div class="cf-modal-product-row"><span class="cf-modal-product-format">'+esc(p.format)+'</span><span class="cf-modal-product-price">'+price+'</span><button class="cf-btn-cart'+(inCart?' in-cart':'')+'" data-variant-id="'+vid+'" data-entry-id="'+esc(entry.id)+'">'+(inCart?'In cart \u2713':'Add to cart')+'</button></div>';
    }).join('');

    rowsEl.querySelectorAll('.cf-btn-cart').forEach(function(btn){
      var vid=parseInt(btn.dataset.variantId,10), eid=btn.dataset.entryId;
      var inCart=btn.classList.contains('in-cart');
      btn.addEventListener('click', function(){ if(btn.classList.contains('in-cart')) removeFromCart(vid,eid,btn,'modal'); else addToCart(vid,eid,btn,'modal'); });
    });

    var viewLink=$modalBackdrop.querySelector('.cf-modal-view-link');
    if(viewLink) viewLink.href=firstP.handle?'/products/'+firstP.handle:'#';

    var body=$modalBackdrop.querySelector('.cf-modal-body');
    if(body) body.scrollTop=0;

    $modalBackdrop.classList.add('open');
    document.body.style.overflow='hidden';
    // Focus the close button for keyboard accessibility
    var closeBtn = $modalBackdrop.querySelector('.cf-modal-close');
    if (closeBtn) setTimeout(function(){ closeBtn.focus(); }, 100);
  }

  var modalTriggerEl = null;
  function closeModal() {
    if($modalBackdrop) $modalBackdrop.classList.remove('open');
    document.body.style.overflow='';
    // Return focus to trigger element
    if (modalTriggerEl) { try { modalTriggerEl.focus(); } catch(e){} modalTriggerEl = null; }
  }

  /* ── Cart ── */
  function addToCart(variantId, entryId, btn, source) {
    btn.disabled=true; btn.textContent='Adding\u2026';
    fetch('/cart/add.json',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})})
    .then(function(r){if(!r.ok) return r.json().then(function(d){throw new Error(d.description||'Error');});return r.json();})
    .then(function(){
      cartVariantIds.add(variantId);
      markInCart(variantId, entryId, source);
      var entry=entriesById.get(entryId);
      if(entry) updatePolyCartHighlight(entry);
      refreshCartBubble(); refreshCartDrawer();
      showToast((entry?entry.chartRef:'Chart')+' added to cart');
    })
    .catch(function(err){btn.disabled=false;btn.textContent='Add to cart';showToast(err.message||'Could not add to cart');});
  }

  function removeFromCart(variantId, entryId, btn, source) {
    btn.disabled=true; btn.textContent='Removing\u2026';
    var updates = {};
    updates[String(variantId)] = 0;
    fetch('/cart/update.json',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})})
    .then(function(r){if(!r.ok) return r.json().then(function(d){throw new Error(d.description||'Error');});return r.json();})
    .then(function(cart){
      // Rebuild cartVariantIds from the returned cart to stay in sync
      cartVariantIds.clear();
      (cart.items||[]).forEach(function(i){cartVariantIds.add(i.variant_id);});
      markNotInCart(variantId, entryId, source);
      var entry=entriesById.get(entryId);
      if(entry) updatePolyCartHighlight(entry);
      // Update all polygon highlights to reflect new cart state
      allMapEntries.forEach(function(e){ updatePolyCartHighlight(e); });
      refreshCartBubble(); refreshCartDrawer();
      showToast((entry?entry.chartRef:'Chart')+' removed from cart');
    })
    .catch(function(err){btn.disabled=false;btn.textContent='In cart \u2713';showToast(err.message||'Could not remove from cart');});
  }

  function markInCart(variantId, entryId, source) {
    // Update modal buttons
    if($modalBackdrop) {
      $modalBackdrop.querySelectorAll('.cf-btn-cart[data-variant-id="'+variantId+'"]').forEach(function(b){
        b.textContent='In cart \u2713'; b.classList.add('in-cart'); b.disabled=false;
        b.onclick=function(){ removeFromCart(variantId, entryId, b, 'modal'); };
      });
    }
    // Update bar button
    if($bar) {
      var barBtn=$bar.querySelector('.cf-bar-btn-cart');
      if(barBtn&&parseInt(barBtn.dataset.variantId,10)===variantId){
        barBtn.textContent='In cart \u2713'; barBtn.classList.add('in-cart'); barBtn.disabled=false;
        barBtn.onclick=function(){ removeFromCart(variantId, entryId, barBtn, 'bar'); };
      }
    }
  }

  function markNotInCart(variantId, entryId, source) {
    // Update modal buttons
    if($modalBackdrop) {
      $modalBackdrop.querySelectorAll('.cf-btn-cart[data-variant-id="'+variantId+'"]').forEach(function(b){
        b.textContent='Add to cart'; b.classList.remove('in-cart'); b.disabled=false;
        b.onclick=function(){ addToCart(variantId, entryId, b, 'modal'); };
      });
    }
    // Update bar button
    if($bar) {
      var barBtn=$bar.querySelector('.cf-bar-btn-cart');
      if(barBtn&&parseInt(barBtn.dataset.variantId,10)===variantId){
        barBtn.textContent='Add to cart'; barBtn.classList.remove('in-cart'); barBtn.disabled=false;
        barBtn.onclick=function(){ addToCart(variantId, entryId, barBtn, 'bar'); };
      }
    }
  }
  function refreshCartBubble(){fetch('/?sections=cart-icon-bubble').then(function(r){return r.json();}).then(function(s){var h=s['cart-icon-bubble'];if(h){var el=document.getElementById('cart-icon-bubble');if(el)el.innerHTML=h;}}).catch(function(){});}
  function refreshCartDrawer(){document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));}
  function fetchCartState(){fetch('/cart.json').then(function(r){return r.json();}).then(function(cart){(cart.items||[]).forEach(function(i){cartVariantIds.add(i.variant_id);});allMapEntries.forEach(function(e){updatePolyCartHighlight(e);});if(activeEntry&&$bar&&$bar.classList.contains('open'))showBar(activeEntry);}).catch(function(){});}
  function updatePolyCartHighlight(entry){
    var poly=polygonsByEntry.get(entry.id);if(!poly)return;
    var inCart=(entry.products||[]).some(function(p){return cartVariantIds.has(p.variantId);});
    var el=poly.getElement?poly.getElement():null;
    if(el) el.classList.toggle('cf-poly-in-cart',inCart);
  }

  /* ── Tooltip ── */
  function showTooltip(e,entry){
    if(isMobile||!$tooltip)return;
    var prods=entry.products||[],pr=getPriceRange(prods);
    var label=CHART_DATA.seriesLabels[entry.series]||entry.series;
    $tooltip.innerHTML='<div class="cf-tt-series" style="color:'+entry.color+'">'+esc(label)+'</div><div class="cf-tt-ref">'+esc(entry.chartRef)+'</div><div class="cf-tt-title">'+esc(entry.shortTitle)+'</div>'+(entry.scale?'<div class="cf-tt-detail">Scale '+esc(entry.scale)+'</div>':'')+(pr?'<div class="cf-tt-detail">'+pr+'</div>':'');
    $tooltip.style.display='block';moveTooltip(e);
  }
  function moveTooltip(e){var off=14,l=e.clientX+off,t=e.clientY+off;if(l+$tooltip.offsetWidth>window.innerWidth-8)l=e.clientX-$tooltip.offsetWidth-off;if(t+$tooltip.offsetHeight>window.innerHeight-8)t=e.clientY-$tooltip.offsetHeight-off;$tooltip.style.left=l+'px';$tooltip.style.top=t+'px';}
  function hideTooltip(){if($tooltip)$tooltip.style.display='none';}
  function getPriceRange(prods){var p=prods.map(function(x){return parseFloat(x.price);}).filter(function(x){return !isNaN(x);});if(!p.length)return'';var mn=Math.min.apply(null,p),mx=Math.max.apply(null,p);return mn===mx?'\u00a3'+mn.toFixed(2):'from \u00a3'+mn.toFixed(2)+'\u2013\u00a3'+mx.toFixed(2);}

  var toastTimer;
  function showToast(msg){if(!$toast)return;$toast.textContent=msg;$toast.classList.add('visible');clearTimeout(toastTimer);toastTimer=setTimeout(function(){$toast.classList.remove('visible');},3000);}

  /* ── Legend ── */
  function buildLegend(entries) {
    if(!$legendRows) return;
    $legendRows.innerHTML = '';
    var counts={};
    entries.forEach(function(e){counts[e.series]=(counts[e.series]||0)+1;});
    var order=['C','Y','M','G','A','B','D','E'];
    order.filter(function(s){return counts[s];}).forEach(function(s){
      var color=CHART_DATA.colors[s], label=CHART_DATA.seriesLabels[s]||s;
      var row=document.createElement('div');
      row.className='cf-legend-row'; row.dataset.series=s;
      row.setAttribute('role','checkbox'); row.setAttribute('aria-checked','true'); row.tabIndex=0;
      row.innerHTML='<div class="cf-legend-check">\u2713</div><div class="cf-legend-swatch" style="background:'+color+';border-color:'+color+'"></div><span class="cf-legend-label">'+esc(label)+'</span><span class="cf-legend-count">'+counts[s]+'</span>';
      row.addEventListener('click',function(){toggleSeries(s);});
      row.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();toggleSeries(s);}});
      $legendRows.appendChild(row);
    });
  }

  function toggleSeries(s){
    seriesVisible[s]=!seriesVisible[s];
    $legendRows.querySelectorAll('.cf-legend-row[data-series="'+s+'"]').forEach(function(r){r.classList.toggle('dimmed',!seriesVisible[s]);r.setAttribute('aria-checked',seriesVisible[s]?'true':'false');});
    applyVisibility();
  }

  function buildTypeFilter(){
    if(!$typeFilterRows)return;
    ALL_TYPES.forEach(function(type){
      var row=document.createElement('div');
      row.className='cf-type-filter-row'; row.dataset.type=type;
      row.setAttribute('role','checkbox'); row.setAttribute('aria-checked','true'); row.tabIndex=0;
      row.innerHTML='<div class="cf-legend-check">\u2713</div><span class="cf-legend-label">'+esc(type)+'</span>';
      row.addEventListener('click',function(){toggleType(type);});
      row.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();toggleType(type);}});
      $typeFilterRows.appendChild(row);
    });
  }

  function toggleType(type){
    typeVisible[type]=!typeVisible[type];
    $typeFilterRows.querySelectorAll('.cf-type-filter-row[data-type="'+type+'"]').forEach(function(r){r.classList.toggle('dimmed',!typeVisible[type]);r.setAttribute('aria-checked',typeVisible[type]?'true':'false');});
    applyVisibility();
  }

  function initLegendClose(){
    if(!$legend)return;
    var closeDiv=document.createElement('div');
    closeDiv.className='cf-legend-close-wrap';
    closeDiv.innerHTML='<button class="cf-legend-close-btn" aria-label="Close">\u2715</button>';
    closeDiv.querySelector('button').addEventListener('click',closeLegend);
    $legend.insertBefore(closeDiv,$legend.firstChild);
    if($legendToggle){$legendToggle.addEventListener('click',function(){$legend.classList.add('open');});}
    // Tap outside legend to close (mobile backdrop)
    document.addEventListener('click',function(e){
      if(!$legend.classList.contains('open'))return;
      if($legend.contains(e.target))return;
      if($legendToggle&&$legendToggle.contains(e.target))return;
      closeLegend();
    });
  }
  function closeLegend(){if($legend)$legend.classList.remove('open');}

  /* ── Search ── */
  var chartSearchIndex=[],currentChartResults=[],currentPlaceResults=[],focusIdx=-1,nominatimTimer,nominatimAbort;
  function buildSearchIndex(all){chartSearchIndex=all.map(function(e){return{entry:e,text:[e.chartRef,e.number,e.shortTitle,e.title,(e.seaAreas||[]).join(' '),e.zone||'',e.region||'',(e.plans||[]).join(' ')].join(' ').toLowerCase()};});}
  function searchIdx(q){var tok=q.trim().toLowerCase().split(/\s+/).filter(Boolean);if(!tok.length)return[];return chartSearchIndex.filter(function(i){return tok.every(function(t){return i.text.indexOf(t)!==-1;});}).map(function(i){return i.entry;}).slice(0,8);}
  function searchNominatim(q){if(nominatimAbort)nominatimAbort.abort();nominatimAbort=new AbortController();return fetch('https://nominatim.openstreetmap.org/search?format=json&limit=4&q='+encodeURIComponent(q)+'&accept-language=en',{signal:nominatimAbort.signal,headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():[];}).catch(function(e){return e.name==='AbortError'?null:[];});}

  function initSearch(){
    if(!$searchInput)return;
    $searchInput.addEventListener('input',function(){var q=$searchInput.value.trim();$searchClear.style.display=q?'block':'none';if(!q){hideDropdown();currentChartResults=[];currentPlaceResults=[];return;}currentChartResults=searchIdx(q);currentPlaceResults=[];if(currentChartResults.length||q.length>=2)renderDropdown();clearTimeout(nominatimTimer);if(q.length>=3)nominatimTimer=setTimeout(function(){searchNominatim(q).then(function(p){if(p===null)return;currentPlaceResults=p||[];renderDropdown();});},500);});
    $searchInput.addEventListener('keydown',function(e){var items=$searchDropdown.querySelectorAll('.cf-search-result');if(!items.length&&e.key!=='Escape')return;if(e.key==='ArrowDown'){e.preventDefault();focusIdx=Math.min(focusIdx+1,items.length-1);items.forEach(function(el,i){el.classList.toggle('focused',i===focusIdx);});}else if(e.key==='ArrowUp'){e.preventDefault();focusIdx=Math.max(focusIdx-1,-1);items.forEach(function(el,i){el.classList.toggle('focused',i===focusIdx);});}else if(e.key==='Enter'&&focusIdx>=0){e.preventDefault();items[focusIdx].click();}else if(e.key==='Escape'){hideDropdown();$searchInput.blur();}});
    $searchInput.addEventListener('focus',function(){if($searchInput.value.trim()&&(currentChartResults.length||currentPlaceResults.length))renderDropdown();});
    $searchClear.addEventListener('click',function(){$searchInput.value='';$searchClear.style.display='none';hideDropdown();currentChartResults=[];currentPlaceResults=[];$searchInput.focus();});
    document.addEventListener('click',function(e){if(!$searchInput.contains(e.target)&&!$searchDropdown.contains(e.target))hideDropdown();});
  }
  function renderDropdown(){var hc=currentChartResults.length>0,hp=currentPlaceResults.length>0;if(!hc&&!hp){$searchDropdown.innerHTML='<div class="cf-search-no-results">No results</div>';$searchDropdown.style.display='block';focusIdx=-1;return;}var html='';if(hc){html+='<div class="cf-search-section-label">Charts</div>';currentChartResults.forEach(function(e,i){html+='<div class="cf-search-result" data-kind="chart" data-idx="'+i+'"><div class="cf-sr-ref" style="color:'+(e.color||'')+'">'+esc(e.chartRef)+'</div><div class="cf-sr-title">'+esc(e.shortTitle)+'</div></div>';});}if(hp){html+='<div class="cf-search-section-label">Places</div>';currentPlaceResults.forEach(function(p,i){html+='<div class="cf-search-result" data-kind="place" data-idx="'+i+'"><div class="cf-sr-ref">'+esc(p.display_name.split(',').slice(0,3).join(','))+'</div></div>';});}$searchDropdown.innerHTML=html;$searchDropdown.style.display='block';focusIdx=-1;$searchDropdown.querySelectorAll('[data-kind="chart"]').forEach(function(el){var i=+el.dataset.idx;el.addEventListener('click',function(){selectChartResult(currentChartResults[i]);});});$searchDropdown.querySelectorAll('[data-kind="place"]').forEach(function(el){var i=+el.dataset.idx;el.addEventListener('click',function(){selectPlaceResult(currentPlaceResults[i]);});});}
  function hideDropdown(){if($searchDropdown)$searchDropdown.style.display='none';focusIdx=-1;}

  function selectChartResult(entry){
    hideDropdown();$searchInput.value=entry.chartRef;$searchClear.style.display='block';
    // Switch to correct mode if needed
    if(entry.series==='pack' && viewMode!=='packs') setMode('packs');
    else if(entry.series!=='pack' && viewMode!=='charts') setMode('charts');
    var coords=entry.coordinates;
    if(coords&&coords.length){try{map.fitBounds(L.polygon(coords).getBounds(),{padding:[60,60]});}catch(e){}}
    // Ensure visible
    var poly=polygonsByEntry.get(entry.id);
    if(poly&&!map.hasLayer(poly)) poly.addTo(map);
    selectEntry(entry);
  }
  function selectPlaceResult(place){hideDropdown();$searchInput.value=place.display_name.split(',').slice(0,2).join(',').trim();$searchClear.style.display='block';var lat=parseFloat(place.lat),lon=parseFloat(place.lon);if(isNaN(lat)||isNaN(lon))return;var zoomMap={country:5,state:6,region:6,county:7,city:8,town:9,village:9,bay:9,sea:7,harbour:11,marina:12,island:9};var mz=zoomMap[place.type]||9;if(place.boundingbox&&place.boundingbox.length===4){var bb=place.boundingbox.map(Number);map.fitBounds([[bb[0],bb[2]],[bb[1],bb[3]]],{padding:[60,60],maxZoom:mz});}else map.setView([lat,lon],mz);}

  function esc(s){return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
})();
